import { render, staticRenderFns } from "./EditRoleForm.vue?vue&type=template&id=8128c3a2&scoped=true"
import script from "./EditRoleForm.vue?vue&type=script&lang=js"
export * from "./EditRoleForm.vue?vue&type=script&lang=js"
import style0 from "./EditRoleForm.vue?vue&type=style&index=0&id=8128c3a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8128c3a2",
  null
  
)

export default component.exports